import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Banner from '../Banner/Banner';
import Projects from '../Projects/Projects';
import Contact from './../Contact/Contact';

const Home = () => {
    return (
        <div className="bg-[#0E1D2F] text-white">
            <Banner></Banner>
            <Projects></Projects>
            <Contact></Contact>
            <Footer></Footer>
        </div>
    );
};

export default Home;